export enum SearchFormFieldNew {
  INITIAL = 'initial',
  DESTINATION = 'destination',
  DATES = 'dates',
  ROOMS_AND_EVENTSPACE = 'roomsAndEventSpace',
  SUMMARY = 'summary',
}
